module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-regular-400.woff2?640500474866e5f6dfa0d4842e575f40";